import axios from 'axios';

let prefix = "/product"
let prefix1 = "/public/product"
const prefix2 = "/public/review";

const ProductApi = {

	getProductList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	// Combined admin list: products AND their variations as flat rows.
	// When `search` is provided, matching variations appear as their own rows.
	getProductListCombined(payload){
		return axios.get( prefix + "/admin-list", {params: payload})
	},
	// FEAT-14. Published products a customer cannot be quoted a shipping fee
	// for, with the reason per product. Read-only — it changes nothing.
	getShippingQuoteReport(payload){
		return axios.get( prefix + "/shipping-quote-report", {params: payload})
	},
	getProductById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createProduct(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateProduct(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveProduct(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	updateProductStatus(payload){
		return axios.post( prefix + "/update-status", payload)
	},
	saveDraft(payload){
		return axios.post( prefix + "/save-draft", payload)
	},
	publishDraft(payload){
		return axios.post( prefix + "/publish-draft", payload)
	},
	getDraftPreview(id, payload){
		return axios.get( prefix + "/draft-preview/" + id, {params: payload})
	},
	discardDraft(payload){
		return axios.delete( prefix + "/discard-draft", {params: payload})
	},
	exportProduct(payload){
		return axios.get( prefix + "/export", {params: payload, responseType: 'blob'})
	},

	downloadCsvTemplate(){
		return axios.get( prefix + "/download-csv-template", {responseType: 'blob'})
	},
	importCsv(formData){
		return axios.post( prefix + "/import-csv", formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	},
	getBatchImportDetails(batchId, params){
		return axios.get( prefix + "/batch-import/" + batchId, {params})
	},
	getBatchImportHistory(params){
		return axios.get( prefix + "/batch-import-history", {params})
	},
	confirmBatchImport(batchId){
		return axios.post( prefix + "/confirm-batch-import/" + batchId)
	},
	deleteBatchImport(batchId){
		return axios.delete( prefix + "/batch-import/" + batchId)
	},
	updateBatchImportItem(payload){
		return axios.post( prefix + "/update-failed-import", payload)
	},

	// Bulk UPDATE of existing products. Separate from the import endpoints
	// above: those only ever create, these only ever change what is already
	// there, and nothing is written until applyBulkUpdate.
	// FEAT-07: mass image upload from a ZIP — review, then apply the same file
	previewProductImageZip(formData){
		return axios.post( prefix + "/image-upload/preview", formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	},
	applyProductImageZip(formData){
		return axios.post( prefix + "/image-upload/apply", formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	},
	uploadBulkUpdate(formData){
		return axios.post( prefix + "/bulk-update/upload", formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	},
	getBulkUpdateDetails(batchId){
		return axios.get( prefix + "/bulk-update/" + batchId)
	},
	getBulkUpdateHistory(params){
		return axios.get( prefix + "/bulk-update-history", {params})
	},
	updateBulkUpdateRow(payload){
		return axios.post( prefix + "/bulk-update/row", payload)
	},
	applyBulkUpdate(batchId){
		return axios.post( prefix + "/bulk-update/" + batchId + "/apply")
	},
	deleteBulkUpdate(batchId){
		return axios.delete( prefix + "/bulk-update/" + batchId)
	},

	// Translation methods
	getProductTranslations(productId) {
		return axios.get(`${prefix}/${productId}/translations`)
	},
	getProductTranslationByLocale(productId, locale) {
		return axios.get(`${prefix}/${productId}/translations/${locale}`)
	},
	saveProductTranslation(productId, payload) {
		return axios.post(`${prefix}/${productId}/translations`, payload)
	},
	deleteProductTranslation(productId, locale) {
		return axios.delete(`${prefix}/${productId}/translations/${locale}`)
	},
	getPreviewProductDetail(productId, params) {
		return axios.get(prefix1 + `/preview/${productId}`, { params })
	},
	getReviewList(payload){
        return axios.get( prefix2 + "/list", { params: payload })
    },

	// Send email notification to vendor about product status updates
	sendVendorStatusNotification(payload) {
		return axios.post(prefix + "/send-vendor-status-notification", payload)
	},

	// Product Labels (Application)
	getProductLabelList(payload){
		return axios.get("/product-label/list", {params: payload})
	},
	createProductLabel(payload){
		return axios.post("/product-label/create", payload)
	},
	updateProductLabel(payload){
		return axios.post("/product-label/update", payload)
	},
	archiveProductLabel(payload){
		return axios.delete("/product-label/delete", {params: payload})
	},

	// Product Functions
	getProductFunctionList(payload){
		return axios.get("/product-function/list", {params: payload})
	},
	createProductFunction(payload){
		return axios.post("/product-function/create", payload)
	},
	updateProductFunction(payload){
		return axios.post("/product-function/update", payload)
	},
	archiveProductFunction(payload){
		return axios.delete("/product-function/delete", {params: payload})
	},

}

export default ProductApi;
